// extracted by mini-css-extract-plugin
export default {"searchList":"src-constrains-Query1-Tags-css__searchList--fl8wF"};